


















import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { QDialog } from 'quasar'
import messenger from 'src/assets/messenger'
import MessengerActivities from 'src/components/messenger/MessengerActivities.vue'
import MessengerChat from 'src/components/messenger/MessengerChat.vue'
import { MessengerActivity } from 'src/graphql/types'

@Component({
  components: {
    MessengerActivities,
    MessengerChat
  }
})
export default class Messenger extends Vue {
  messenger = messenger

  @Ref()
  readonly dialog!: QDialog

  @Watch('messenger.chat.activity')
  focus () {
    this.$nextTick(() => {
      this.dialog.focus()
    })
  }

  async show (activity?: MessengerActivity) {
    if (activity) {
      this.messenger.chatOpen(this.messenger.activitySetup(activity))
    }
    this.dialog.show()
  }

  hide () {
    this.messenger.chatClose()
    this.dialog.hide()
  }

  escape (e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.hide()
    }
  }
}
